module.exports = __webpack_public_path__ + "img/report-bg.435bdea7.png";